import { id, Identifiable, role, Zone } from "@planzone/dto";
import { Selector, State } from "./types";

function createSelector(getState: () => State): Selector {
  return {
    getZoneRole({ uuid }: Identifiable<Zone>) {
      const req = getState().find(({ zone }) => zone.uuid === uuid);

      return req ? req.role : { ...role, uuid: id };
    },
    isRetrieveZoneRoleRequestFailure({ uuid }: Identifiable<Zone>) {
      const req = getState().find(({ zone }) => zone.uuid === uuid);

      return req ? req.request.isFailure : false;
    },
    isRetrieveZoneRoleRequestPending({ uuid }: Identifiable<Zone>) {
      const req = getState().find(({ zone }) => zone.uuid === uuid);

      return req ? req.request.isPending : false;
    },
    isRetrieveZoneRoleRequestSuccess({ uuid }: Identifiable<Zone>) {
      const req = getState().find(({ zone }) => zone.uuid === uuid);

      return req ? req.request.isSuccessful : false;
    },
  };
}

export { createSelector };
